import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9swhtreag5: FaireBrandEntity = {
  token: "b_9swhtreag5",
  type: "brand",
  name: "Sweetkama",
  avatarUrl:
    "https://cdn.faire.com/fastly/075fe721f3523fe2b9504ccbe3cc53c4a4ab72bed465123fe3912b8b15ccb6e7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4fa604fda79fca151cbcb7f5972ddde4e484df8defbfecf5a3613655cfe44df3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/075fe721f3523fe2b9504ccbe3cc53c4a4ab72bed465123fe3912b8b15ccb6e7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4fa604fda79fca151cbcb7f5972ddde4e484df8defbfecf5a3613655cfe44df3.jpeg",
  location: "Corona, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.3,
  reviewCount: 699,
  isInsider: true,
  description:
    "🌟 Sweetkama: Your Fashion Partner-Turning fashion vision into scalable success.\nWelcome to Sweetkama! We are based in Los Angeles, with a 12,000 sq ft warehouse dedicated to bringing trendy designs and great value to women's fashion.\n\nAs customer demand grew over the years, we expanded our capabilities in 2018 by investing in our own production line in China. Our China facility is substantial, including a 21,500+ sq ft production workshop, a 16,000+ sq ft warehouse, and a 10,700+ sq ft office.\n\nWe offer a variety of nice products, from everyday wear to intimates, and provide professional customization options, including: Personalized Labels, Logo Print, ODM, and OEM.\n\nOur focus is on delivering great value, comfort, price, design, and nice customer service to ensure you are happy with every shopping experience.\n\nShipping & Logistics: Dual Warehouse System\nTo ensure efficient order fulfillment and fast service, Sweetkama operates a dual warehouse system. Products may ship from either our Los Angeles (LA) Warehouse or our China Factory Warehouse. This flexible approach allows us to quickly fulfill all orders, especially if stock depletion in LA is quicker than our ocean freight resupply schedule.\n\nThank you for choosing Sweetkama. We look forward to building long-term relationships with you!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:09.676Z",
    importedBy: "entity-db-cli",
  },
};
